import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, API_BASE } from "@/lib/api";
import { Award, Download, ArrowLeft } from "lucide-react";

export default function CertificatePage() {
  const { certId } = useParams();
  const [cert, setCert] = useState(null);

  useEffect(() => {
    api.get("/api/student/certificates").then(({ data }) => {
      setCert(data.find((c) => c.id === certId));
    });
  }, [certId]);

  const downloadPdf = async () => {
    const resp = await api.get(`/api/student/certificate/${certId}/download`, { responseType: "blob" });
    const blob = new Blob([resp.data], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `certificate-${cert.cert_number}.pdf`;
    a.click();
    URL.revokeObjectURL(url);
  };

  if (!cert) return <div className="py-24 text-center">Loading...</div>;

  return (
    <div className="max-w-4xl mx-auto px-6 py-12" data-testid="certificate-page">
      <Link to="/dashboard" className="text-sm text-[#D92D20] font-semibold flex items-center gap-1"><ArrowLeft className="w-4 h-4" /> Dashboard</Link>

      <div className="mt-6 bg-white border-4 border-[#D92D20] rounded-2xl p-10 md:p-16 text-center shadow-sm relative overflow-hidden">
        <div className="absolute inset-2 border border-[#064E3B] rounded-xl pointer-events-none" />
        <div className="relative">
          <div className="label-eyebrow text-[#D92D20]">TeachMeOnline.ca</div>
          <h1 className="font-display font-black text-4xl md:text-6xl mt-3 tracking-tight">{cert.certificate_title}</h1>
          <p className="mt-6 text-[#4B5563]">This certificate is proudly presented to</p>
          <div className="mt-3 font-display font-black text-3xl md:text-5xl text-[#064E3B] tracking-tight">{cert.student_name}</div>
          <p className="mt-6 text-[#4B5563]">for successfully completing the course</p>
          <div className="mt-2 font-display font-bold text-xl md:text-3xl">{cert.course_title}</div>
          <div className="mt-10 grid grid-cols-2 gap-4 text-left max-w-md mx-auto">
            <div>
              <div className="label-eyebrow">Issued</div>
              <div className="font-display font-bold">{new Date(cert.issued_at).toLocaleDateString("en-CA", { year: "numeric", month: "long", day: "numeric" })}</div>
            </div>
            <div className="text-right">
              <div className="label-eyebrow">Certificate ID</div>
              <div className="font-mono text-sm">{cert.cert_number}</div>
            </div>
          </div>
          <p className="mt-8 text-xs text-[#4B5563] italic">Certificate of Completion — educational. Not an accredited degree or licensure.</p>
        </div>
      </div>

      <div className="mt-8 flex justify-center gap-3">
        <button onClick={downloadPdf} data-testid="download-pdf" className="btn-primary flex items-center gap-2">
          <Download className="w-4 h-4" /> Download PDF
        </button>
        <Link to="/courses" className="btn-outline flex items-center gap-2" data-testid="learn-more">
          <Award className="w-4 h-4" /> Take another course
        </Link>
      </div>
    </div>
  );
}
